// extracted by mini-css-extract-plugin
export default {"bgFixed":"Background_bgFixed__fMKCQ"};